import React from 'react';

import {Box} from '@spothero/ui';

const labelStyles = {
    fontSize: 'sm',
    fontWeight: 'semibold',
    color: 'text.secondary.light',
    minHeight: 4,
    display: 'block',
    lineHeight: 1.15,
    marginBottom: 1,
} as const;

type FormLabelProps = {
    children: React.ReactNode;
    htmlFor?: string;
    id?: string;
} & React.ComponentProps<typeof Box>;

const FormLabel = ({children, htmlFor, id, ...rest}: FormLabelProps) => {
    return (
        // `Box` rather than `Text` because @spothero/ui's `Text` is not
        // polymorphic (plain ForwardRefExoticComponent), so it rejects the
        // `htmlFor` that `as="label"` requires. Every visual property is set
        // explicitly in `labelStyles`, so rendering is unchanged.
        <Box
            htmlFor={htmlFor}
            id={id}
            as={htmlFor || id ? 'label' : 'p'}
            {...labelStyles}
            {...rest}
        >
            {children}
        </Box>
    );
};

export default FormLabel;
